type BrowserCrypto = {
  getRandomValues?: (values: Uint8Array) => Uint8Array;
  randomUUID?: () => string;
};

let fallbackSequence = 0;

function formatUuid(bytes: Uint8Array): string {
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0'));
  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join(''),
  ].join('-');
}

/** Creates an idempotency key on browsers where randomUUID requires HTTPS. */
export function createCommandId(cryptoOverride?: BrowserCrypto): string {
  const browserCrypto = cryptoOverride ?? (
    typeof globalThis.crypto === 'object' ? globalThis.crypto : undefined
  );

  if (typeof browserCrypto?.randomUUID === 'function') {
    return browserCrypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  if (typeof browserCrypto?.getRandomValues === 'function') {
    browserCrypto.getRandomValues(bytes);
  } else {
    fallbackSequence = (fallbackSequence + 1) >>> 0;
    const now = Date.now();
    for (let index = 0; index < bytes.length; index += 1) {
      const timestampByte = Math.floor(now / 2 ** ((index % 6) * 8)) & 0xff;
      const sequenceByte = (fallbackSequence >>> ((index % 4) * 8)) & 0xff;
      bytes[index] = Math.floor(Math.random() * 256) ^ timestampByte ^ sequenceByte;
    }
  }

  return formatUuid(bytes);
}
